import { useMemo } from "react";
import { useExportExcel } from "../../../../../lib/hooks/exportExcel";
import IncidentReportsService from "../../../../../services/incidentReports";
import { Form, FormInstance } from "antd";

export const useExport = (form: FormInstance, closeModal: () => void) => {
  const type = Form.useWatch("dateRangeType", form);

  const dates = Form.useWatch("dates", form);

  const request = useMemo(() => {
    if (type !== 5) {
      return { dateRangeType: type };
    }

    if (dates) {
      return {
        dateFrom: dates[0].format(),
        dateTo: dates[1].format(),
        dateRangeType: 5,
      };
    }

    return {};
  }, [dates, type]);

  const { onExportExcelButtonClicked: onExport, isLoading } = useExportExcel(
    IncidentReportsService,
    request,
    "incidents.xlsx",
    closeModal,
  );

  return { onExport, isLoading };
};
